import { gql } from "@apollo/client";

import {
  ListTagsAndGroupsQuery,
  ListTagsAndGroupsWithIntegrationsQuery,
  ListTagsQuery,
  ListTagsWithIntegrationsQuery,
} from "~frontend/__generated__/graphql";

export const LIST_TAGS = gql`
  query listTags($input: ListTagsInput!) {
    listTags(input: $input) {
      id
      name
      createdAt
    }
  }
`;

export const LIST_TAGS_AND_GROUPS = gql`
  query listTagsAndGroups($subaccountId: String!) {
    listTags(input: { subaccountId: $subaccountId }) {
      id
      name
      createdAt
    }
    listTagGroups(input: { subaccountId: $subaccountId }) {
      id
      name
      createdAt
      tags {
        id
        name
        createdAt
      }
    }
  }
`;

const TAG_DETAIL_FIELDS = gql`
  fragment TagDetailFields on Tag {
    __typename
    id
    name
    createdAt
    integrationActions {
      id
      integration {
        id
        service
        name
      }
      ngpVanMyCampaignActions {
        __typename
        ... on NgpVanTagIntegrationActionApplyActivistCode {
          actionType
          activistCodeId
          activistCode {
            id
            activistCodeId
            name
          }
        }
        ... on NgpVanTagIntegrationActionApplyResultCode {
          actionType
          resultCodeId
          resultCodeName
        }
        ... on NgpVanTagIntegrationActionApplySurveyResponse {
          actionType
          surveyQuestionId
          surveyQuestion {
            id
            surveyQuestionId
            name
            responses {
              surveyResponseId
              name
            }
          }
          surveyResponseId
        }
      }
      ngpVanMyVotersActions {
        __typename
        ... on NgpVanTagIntegrationActionApplyActivistCode {
          actionType
          activistCodeId
          activistCode {
            id
            activistCodeId
            name
          }
        }
        ... on NgpVanTagIntegrationActionApplyResultCode {
          actionType
          resultCodeId
          resultCodeName
        }
        ... on NgpVanTagIntegrationActionApplySurveyResponse {
          actionType
          surveyQuestionId
          surveyQuestion {
            id
            surveyQuestionId
            name
            responses {
              surveyResponseId
              name
            }
          }
          surveyResponseId
        }
      }
    }
  }
`;

const TAG_GROUP_DETAIL_FIELDS = gql`
  ${TAG_DETAIL_FIELDS}

  fragment TagGroupDetailFields on TagGroup {
    __typename
    id
    name
    createdAt
    tags {
      ...TagDetailFields
    }
  }
`;

export const LIST_TAGS_WITH_INTEGRATIONS = gql`
  ${TAG_DETAIL_FIELDS}

  query listTagsWithIntegrations($input: ListTagsInput!) {
    listTags(input: $input) {
      ...TagDetailFields
    }
  }
`;

export const LIST_TAGS_AND_GROUPS_WITH_INTEGRATIONS = gql`
  ${TAG_DETAIL_FIELDS}
  ${TAG_GROUP_DETAIL_FIELDS}

  query listTagsAndGroupsWithIntegrations($subaccountId: String!) {
    listTags(input: { subaccountId: $subaccountId }) {
      ...TagDetailFields
    }

    listTagGroups(input: { subaccountId: $subaccountId }) {
      ...TagGroupDetailFields
    }
  }
`;

export const CREATE_TAG = gql`
  mutation createTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      name
    }
  }
`;

export const EDIT_TAG = gql`
  ${TAG_DETAIL_FIELDS}

  mutation editTag($input: EditTagInput!) {
    editTag(input: $input) {
      ...TagDetailFields
    }
  }
`;

export const CREATE_TAG_GROUP = gql`
  mutation createTagGroup($input: CreateTagGroupInput!) {
    createTagGroup(input: $input) {
      id
      name
    }
  }
`;

export const EDIT_TAG_GROUP = gql`
  ${TAG_GROUP_DETAIL_FIELDS}

  mutation editTagGroup($input: EditTagGroupInput!) {
    editTagGroup(input: $input) {
      ...TagGroupDetailFields
    }
  }
`;

export const DELETE_TAGS = gql`
  mutation deleteTags($input: DeleteTagsInput!) {
    deleteTags(input: $input) {
      success
    }
  }
`;

export const DELETE_TAG_GROUPS = gql`
  mutation deleteTagGroups($input: DeleteTagGroupsInput!) {
    deleteTagGroups(input: $input) {
      success
    }
  }
`;

export type ListTagsTag = ListTagsQuery["listTags"][number];
export type ListTagsTagGroup = ListTagsAndGroupsQuery["listTagGroups"][number];
export type ListTagsTagOrGroup = ListTagsTag | ListTagsTagGroup;

export type ListTagsWithIntegrationsTag =
  ListTagsWithIntegrationsQuery["listTags"][number];

export type TagDetail =
  ListTagsAndGroupsWithIntegrationsQuery["listTags"][number];
export type TagGroupDetail =
  ListTagsAndGroupsWithIntegrationsQuery["listTagGroups"][number];
export type TagOrGroupDetail = TagDetail | TagGroupDetail;
